import React, { useEffect } from "react";
import { API } from 'aws-amplify';
import { onError } from "../libs/errorLib";

const apiName = 'SciHackRestApi';
const path = '/price';
const myInit = { // OPTIONAL
  headers: {}, // OPTIONAL
  response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
  queryStringParameters: { 
    description: 'sunshine duration monthly mean daily duration',
    fileName: 'sunshine-duration-monthly-mean-daily-duration.csv',
    triggerPayout: '1000',
    triggerLevel: '5',
    triggerCondition: '<',
    projectionPeriods: '12'
  }
};

/* API
  .get(apiName, path, myInit)
  .then(response => {
    // Add your code here
  })
  .catch(error => {
    console.log(error.response);
 }); */

export default function TestAPI() {
  useEffect(() => {
    const getData = async () => {
      try {
        const response = await API.get(apiName, path, myInit)
        console.log(response.data.output)
        console.log('disc_rate: ' + response.data.disc_rate);
        console.log('loading: ' + response.data.loading);
        console.log('pure_premium: ' + response.data.pure_premium);
        console.log('loaded_premium: ' + response.data.loaded_premium)
      } catch (error) {
        //setIsError(true);
        onError(error);
        console.log(error.response);
      }
    };
    getData();
  }, []);

  return (
      <div>
        <main className="flex-shrink-0">
          <div className="container">
            <h4 className="mt-3">Test Rest API</h4>
    
            </div>
        </main>
      </div>
    );
};